/* Remove-from-cart without leaving the page.
 *
 * snippets/cart-item.liquid renders remove as a plain link:
 *   <a href="{{ routes.cart_change_url }}?id={{ product.key }}&quantity=0">
 * With nothing intercepting it the browser follows /cart/change, which 302s to /cart - so
 * clicking remove inside the drawer reloads the whole page and dumps the customer on the
 * cart page instead of leaving the drawer open.
 *
 * The quantity buttons next to it do not have this problem: they dispatch cart:quantity
 * and the CartForm updates over AJAX. They cannot be used for removal though, because
 * QtySelector._change() clamps to the input's min, so minus can never reach 0.
 *
 * This listens on document rather than on the links, because the drawer re-renders its
 * contents on every cart change and per-link handlers would be lost on the first update.
 * It reuses the theme's own theme.cart.changeItem() and its cart:build event rather than
 * reimplementing the request, and if either is missing it lets the original link proceed -
 * a full page reload is a poor experience, but silently failing to remove is worse.
 */
(function () {
  var SELECTOR = '.cart__remove a[href*="quantity=0"]';

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest ? evt.target.closest(SELECTOR) : null;
    if (!link) return;

    var id;
    try {
      id = new URL(link.href, window.location.origin).searchParams.get('id');
    } catch (e) {
      id = null;
    }
    if (!id || !window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') {
      return;                      // no interception: the link still works
    }

    evt.preventDefault();
    if (link.dataset.removing === '1') return;   // double-click guard
    link.dataset.removing = '1';
    link.style.opacity = '0.5';

    theme.cart
      .changeItem(id, 0)
      .then(function (cart) {
        var parsed = null;
        try { parsed = JSON.parse(cart); } catch (e) {}
        if (parsed && parsed.status === 422) {
          window.location = link.href;           // let Shopify show the real error
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (parsed) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsed } }));
        }
      })
      .catch(function () {
        window.location = link.href;             // fall back to the original behaviour
      });
  });
})();
